import React from 'react';
import classes from './SubscribeForm.css';
import { gciPageView } from '../../../lib/analytics';

const pageTitle = 'Subscribe to The Huddle';

class SubscribeForm extends React.Component {
  componentDidMount() {
    document.title = `${pageTitle} - TheHuddle`;
    gciPageView(pageTitle);
  }

  render() {
    return (
      <div className={classes.SubscribeForm}>
        <h1>{pageTitle}</h1>
        <p>
          The Huddle is no longer accepting new subscriptions.
          Already a member? <a className={classes.signIn} href="/login">Sign in</a>
        </p>
      </div>
    );
  }
}

export default SubscribeForm;



// WEBPACK FOOTER //
// ./src/app/views/Subscribe/SubscribeForm.js